import {
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { MyProgramsService } from './my-programs.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject } from 'rxjs';

import SwiperCore, {
  Keyboard,
  Pagination,
  Navigation,
  Virtual,
  SwiperOptions,
} from 'swiper';

SwiperCore.use([Keyboard, Pagination, Navigation, Virtual]);

@Component({
  selector: 'app-my-programs',
  templateUrl: './my-programs.component.html',
  styleUrls: ['./my-programs.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MyProgramsComponent implements OnInit {
	@ViewChild('editModal')
	editModal!: TemplateRef<any>;

	config: SwiperOptions = {
		slidesPerView: 3,
		spaceBetween: 50,

		navigation: true,
		pagination: { clickable: true },
		scrollbar: { draggable: true },
	};

	math = Math;
	slides$ = new BehaviorSubject<string[]>(['']);

	images = [944, 1011, 984].map((n) => `https://picsum.photos/id/${n}/900/500`);
	programData: any;
	currentEnrolments: any;
	isCompleted: any;
	loading = true;
	currentCourse: any[] = [];

	constructor(
		private myProgramsService: MyProgramsService,
		private modalService: NgbModal
	) {}

	async ngOnInit() {
		this.slides$.next(Array.from({ length: 600 }).map((el, index) => `Slide ${index + 1}`));
	}

	getUser() {
		return localStorage.getItem('username');
	}

	getGroupId() {
		return localStorage.getItem('groupId');
	}
	getOrgId() {
		return localStorage.getItem('orgId');
	}

	getImage(img: string) {
		const url = `https://s3-ap-southeast-2.amazonaws.com/${img}`;
		return url;
	}
}
